import { Stack, Typography } from '@mui/material';
import { crowdsaleModel } from 'entities/crowdsale';
import { formatToken, fromDecimals, LinearProgressWithLabel, useShallowSelector } from 'shared';

const ADDITION_TO_PROGRESS = 330_000;

export const CrowdsaleProgress = () => {
  const { usdTotalRaised: usdTotalRaisedInDec, usdTotalCount } = useShallowSelector(
    crowdsaleModel.selectors.getCrowdsale,
  );
  const usdTotalRaised = Number(fromDecimals(usdTotalRaisedInDec)) + ADDITION_TO_PROGRESS;
  const usdProgress = (usdTotalRaised * 100) / usdTotalCount;

  const usdRoundedProgress =
    usdProgress !== 0 && usdProgress < 0.01 ? 0.01 : Math.round((usdProgress + Number.EPSILON) * 100) / 100;

  return (
    <Stack mt={1.5} spacing={1}>
      <Typography className="secondary">USD Raised: {formatToken(usdTotalRaised, 0)} USD</Typography>
      <LinearProgressWithLabel value={usdRoundedProgress} />
    </Stack>
  );
};
